export const navLinks = [
  { id: "updates", label: "实时追更" },
  { id: "reversal", label: "反转档案" },
  { id: "timeline", label: "时间线" },
  { id: "columns", label: "阅读专区" },
  { id: "guide", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export const breakingTicker = [
  "某热播剧收官后主创团队直播回应争议，评论区炸了",
  "网传综艺「临时下架」剧情迎来第二次反转，官方已二次回应",
  "当红主播言论被扒旧账，本人凌晨发文澄清并晒出录屏",
  "品牌方紧急切割代言人？多方口径不一，进入待证实阶段",
  "年度热议事件复盘上线，编年史时间线已更新至本周",
];

export const trendingSearch = [
  "后续进展汇总",
  "本次反转可信吗",
  "瓜田本周热度榜",
  "事件完整时间线",
  "实锤与传闻怎么分",
];

export const featuredLead = {
  kicker: "主编今日聚焦",
  title: "一条热点的「三次反转」：当多方口径冲突，谁在替真相着急",
  summary:
    "从一句无心的发言，到网帖发酵、当事人两轮回应、再到第三方下场佐证——同一个事件在一周内经历三次方向翻转。我们尝试把散落在各平台的信息按时间归位，看看舆论为什么总在「实锤」与「辟谣」之间反复横跳。",
  tag: "深度追踪",
  points: [
    "首发源头与传播路径还原",
    "两轮回应文本逐句比对",
    "待证实信息的判断方法论",
  ],
};

export const heroGuide = [
  { n: "01", t: "后续进展", d: "每条热点走向的最新脉络" },
  { n: "02", t: "最新反转", d: "只收录有依据的转向节点" },
  { n: "03", t: "事件更新", d: "滚动快讯，第一时间抵达" },
  { n: "04", t: "瓜田动态", d: "本周值得跟进的热度盘点" },
];

export const feedTabs = [
  { key: "all", label: "全部动态" },
  { key: "follow", label: "后续进展" },
  { key: "reversal", label: "最新反转" },
  { key: "news", label: "事件更新" },
  { key: "hotpot", label: "瓜田动态" },
];

export interface FeedItem {
  id: string;
  tab: "follow" | "reversal" | "news" | "hotpot";
  time: string;
  badge: string;
  title: string;
  desc: string;
  tags: string[];
  heat: number;
  state: "已证实" | "待证实" | "反转节点" | "快讯";
}

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    tab: "follow",
    time: "12:38",
    badge: "热点",
    title: "热播剧争议后团队首度直播回应，否认「加戏」说法",
    desc: "主创在直播中出示拍摄场次表，逐条回应观众质疑；目前该说法仍属单方口径，我们已在时间线中标记为「待证实」。",
    tags: ["剧集", "直播回应"],
    heat: 98,
    state: "待证实",
  },
  {
    id: "f2",
    tab: "reversal",
    time: "11:52",
    badge: "反转",
    title: "综艺嘉宾「被剪事件」迎来反转：完整片段流出",
    desc: "此前流传的片段疑似只截取了中段，完整素材流出后，前情与后续补齐，舆论方向明显转向。本次已计入反转档案。",
    tags: ["综艺", "片段造假"],
    heat: 96,
    state: "反转节点",
  },
  {
    id: "f3",
    tab: "news",
    time: "11:20",
    badge: "快讯",
    title: "当红主播旧账被扒，凌晨发文晒原始录屏澄清",
    desc: "针对早前网传言论，主播晒出带时间戳的录屏回应，称相关表述被断章取义。目前第三方平台暂未给出进一步说明。",
    tags: ["主播", "澄清"],
    heat: 91,
    state: "已证实",
  },
  {
    id: "f4",
    tab: "hotpot",
    time: "10:44",
    badge: "盘点",
    title: "本周瓜田热度榜：四条线索进入持续跟进名单",
    desc: "编辑部汇总本周讨论度上升的线索，含剧集争议、综艺反转、品牌代言变动与主播澄清，均已建立独立档案。",
    tags: ["周榜", "复盘"],
    heat: 88,
    state: "已证实",
  },
  {
    id: "f5",
    tab: "follow",
    time: "10:03",
    badge: "热点",
    title: "品牌方代言合作变动被曝，多方口径不一致",
    desc: "「主动解约」与「合约到期」两种说法并存，品牌官方暂未置评。在官方口径出现前，该条目将持续保持待证实状态。",
    tags: ["商务", "代言"],
    heat: 85,
    state: "待证实",
  },
  {
    id: "f6",
    tab: "reversal",
    time: "09:31",
    badge: "反转",
    title: "所谓「内部截图」被证伪造，创作者公开致歉",
    desc: "经技术比对，流传截图存在明显拼接痕迹，发布者已承认系伪造并删除相关内容。谣言传播路径已整理进档案。",
    tags: ["P图", "辟谣"],
    heat: 82,
    state: "反转节点",
  },
  {
    id: "f7",
    tab: "news",
    time: "09:02",
    badge: "快讯",
    title: "主办方回应演唱会换人传闻：演出阵容未变更",
    desc: "针对网络流传的嘉宾调整消息，主办方工作人员回复媒体称目前无变更计划，正式公告将稍后发布。",
    tags: ["演出", "官方回应"],
    heat: 76,
    state: "已证实",
  },
  {
    id: "f8",
    tab: "hotpot",
    time: "08:26",
    badge: "盘点",
    title: "跨平台联动引热议：同一事件在不同平台的「时差」",
    desc: "梳理发现，多数反转信息在 A 平台发酵、却在 B 平台被证伪，信息时差成为误读主因。我们整理了常见误读链路。",
    tags: ["传播", "观察"],
    heat: 74,
    state: "已证实",
  },
  {
    id: "f9",
    tab: "follow",
    time: "昨日 23:41",
    badge: "热点",
    title: "深夜发帖再引波澜，话题热度攀升进入观察名单",
    desc: "当事人深夜新帖未直接回应核心质疑，评论区讨论度再次上升。编辑部已将其列入明晨优先跟进名单。",
    tags: ["深夜发帖", "跟进"],
    heat: 71,
    state: "待证实",
  },
];

export interface ReversalCard {
  id: string;
  no: string;
  stage: string;
  title: string;
  lead: string;
  img: string;
  alt: string;
}

export const reversalCards: ReversalCard[] = [
  {
    id: "r1",
    no: "档案 006",
    stage: "二度反转",
    title: "综艺「下架」传闻：从热议到澄清只用半天",
    lead: "从「全网热议」到「官方称未下架」，再到完整片段佐证，一次典型的三段式反转样本。",
    img: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20collage%20of%20a%20vintage%20television%20broadcasting%20news%20signals%2C%20warm%20paper%20background%20with%20melon%20green%20and%20coral%20red%20accents%2C%20newspaper%20clippings%20texture%2C%20modern%20magazine%20layout%2C%20soft%20studio%20lighting%2C%20flat%20illustration%20style&width=800&height=560&seq=gt-rev-01&orientation=landscape",
    alt: "综艺下架传闻三段式反转档案封面",
  },
  {
    id: "r2",
    no: "档案 005",
    stage: "实锤反转",
    title: "「内部聊天截图」确认为伪造的完整取证链",
    lead: "我们记录下从截图流出、技术比对、到发布者认错的整个过程，并附上识别伪造截图的三个要点。",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20magnifying%20glass%20over%20a%20document%20with%20warning%20stamps%2C%20warm%20cream%20background%2C%20melon%20green%20and%20amber%20accent%20colors%2C%20newspaper%20style%20borders%2C%20clean%20composition&width=800&height=560&seq=gt-rev-02&orientation=landscape",
    alt: "伪造聊天截图取证链反转档案封面",
  },
  {
    id: "r3",
    no: "档案 004",
    stage: "辟谣反转",
    title: "断章取义：一段 15 秒音频被误解成完整表态",
    lead: "缺失上下文是误读重灾区。本档案收录音频前情，还原被删去的关键 30 秒，帮你在下判断前补全信息。",
    img: "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20an%20audio%20waveform%20timeline%20with%20a%20cut%20marker%20and%20playhead%2C%20cream%20paper%20texture%2C%20coral%20and%20forest%20green%20palette%2C%20vintage%20print%20style&width=800&height=560&seq=gt-rev-03&orientation=landscape",
    alt: "断章取义音频误解反转档案封面",
  },
];

export interface TimelineNode {
  phase: string;
  title: string;
  text: string;
  state: "已证实" | "待证实" | "有争议";
}

export const timelineNodes: TimelineNode[] = [
  {
    phase: "第 1 天 · 00:20",
    title: "一句发言在直播中被截取流出",
    text: "博主直播中的某句话被单独剪辑，配以煽动性标题在各平台扩散，浏览量数小时突破峰值。",
    state: "已证实",
  },
  {
    phase: "第 1 天 · 06:10",
    title: "第一轮网帖发酵，质疑迅速升温",
    text: "多个账号围绕该片段展开解读，部分解读偏离原意，形成「上纲上线」的讨论方向。",
    state: "已证实",
  },
  {
    phase: "第 2 天 · 09:30",
    title: "当事人发布第一轮澄清",
    text: "本人晒出直播回放与逐字稿，指出相关表述被断章取义；但仍有部分网友持保留态度。",
    state: "待证实",
  },
  {
    phase: "第 2 天 · 18:00",
    title: "第三方佐证流出，出现反转",
    text: "有在场观众晒出完整视角录像，与当事人说法互相印证，舆论方向开始明显转向。",
    state: "反转节点",
  },
  {
    phase: "第 3 天 · 11:20",
    title: "原始发布者承认剪辑并删除",
    text: "原始切片账号致歉并删除内容，事件进入收尾。完整链条已归入反转档案 006。",
    state: "已证实",
  },
];

export const deepRead = {
  title: "深读 | 为什么吃瓜总在「实锤」和「辟谣」之间反复横跳",
  summary:
    "当一条信息在 24 小时内连续转向，往往是「传播速度」跑赢了「核实速度」。这篇长文拆解反转发生前的三个前置条件，以及普通读者如何用 10 分钟完成一次自我核查。",
  tags: ["传播学", "方法论", "避坑"],
  points: [
    "先看源头：首发账号的可信度与历史记录",
    "再找时间戳：截图与录屏是否可交叉印证",
    "最后等官方：在口径出现前保持「待证实」心态",
  ],
  img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20people%20reading%20newspapers%20and%20checking%20phones%20inside%20a%20cozy%20melon%20field%20shack%2C%20warm%20cream%20and%20green%20tones%2C%20coral%20accents%2C%20vintage%20print%20magazine%20aesthetic%2C%20soft%20lighting&width=1200&height=760&seq=gt-deep-01&orientation=landscape",
  alt: "深读栏目配图-吃瓜信息核查场景",
};

export interface ReadingCol {
  id: string;
  name: string;
  desc: string;
  count: number;
  tone: string;
}

export const readingCols: ReadingCol[] = [
  { id: "c1", name: "后续进展", desc: "同一话题的持续走向跟踪", count: 128, tone: "primary" },
  { id: "c2", name: "最新反转", desc: "依据充分的方向性转向档案", count: 76, tone: "accent" },
  { id: "c3", name: "事件更新", desc: "滚动快讯与即时要闻", count: 342, tone: "secondary" },
  { id: "c4", name: "瓜田动态", desc: "周榜盘点与跨平台观察", count: 54, tone: "foreground" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "大雷网站是正规的追更平台吗？站内什么内容都能看？",
    a: "大雷网站是一个面向吃瓜用户的资讯聚合与脉络梳理平台，聚焦娱乐与公众热点话题的后续进展、反转与事件梳理。站内展示与转载的内容均经过编辑团队的信息核校，坚持对事实负责、对当事人保有基本尊重的发布原则。",
  },
  {
    q: "「后续进展」「最新反转」「事件更新」这些栏目怎么理解？",
    a: "「后续进展」用于汇总某条热点发布后的最新走向；「最新反转」只收录经过多方信息比对、出现明显转向的节点；「事件更新」是滚动更新的短讯快报；「瓜田动态」则是聚合了本周热度较高、值得跟进的多条线索的综合盘点。",
  },
  {
    q: "爆料和传闻有人核实吗？如何保证内容质量？",
    a: "会。编辑团队对每条进入时间线的信息都做了来源标注与多方交叉核对，将「已证实」「待证实」「反转节点」三类状态明确区分，并以显著标识提示读者哪些信息仍属传闻，避免未经验证的说法被当作事实传播。",
  },
  {
    q: "我想投稿线索或纠正站内信息，可以吗？",
    a: "欢迎。您可通过页面底部订阅表单留言或站内投稿入口提交线索。对于站内已梳理内容中存在的偏差，我们同样欢迎您指出，经核实后会在对应时间线与档案中及时更新标注。",
  },
  {
    q: "订阅追更通知是免费的吗？会不会有骚扰推送？",
    a: "订阅追更完全免费。订阅后仅在您关注的话题出现重要反转或新进展时发送提醒，不会进行无关推送，您也可以随时退订。",
  },
];

export const testimonials = [
  {
    name: "追更十年的「老瓜农」",
    role: "活跃读者",
    text: "最喜欢站内把「已证实」「待证实」「反转」分开标清楚，刷到反转前至少知道哪个是真话。",
  },
  {
    name: "阿澈",
    role: "社媒运营",
    text: "事件时间线帮了大忙，写舆情复盘时不用自己一个个平台翻时间戳，直接照着整理就够了。",
  },
  {
    name: "不吃瓜睡不着",
    role: "普通用户",
    text: "订阅只推真正有进展的，不刷屏不催更，退订也很方便，体验在同类站里算清爽的。",
  },
];

export const valueProps = [
  { icon: "ri-focus-3-line", title: "脉络优先", desc: "每条热点都重建完整时间线，拒绝零散碎片。" },
  { icon: "ri-shield-check-line", title: "状态分层", desc: "已证实、待证实、反转节点一目了然，不替你做判断。" },
  { icon: "ri-file-search-line", title: "来源标注", desc: "关键信息标注出处，方便你自行核对原始内容。" },
];